<template>
  <v-card flat>
    <v-row>
      <div v-for="day in scheduleFiltered" :key="day.id">
        <v-col style="padding-left: 5px; padding-right: 5px;">
          <div v-if="day.id === scheduleDay.id">
            <v-btn small depressed  class="date-button" color="accent" @click="showDay(day)">{{dayName(day)}} <br>{{crewName(day.crew)}} </v-btn>
          </div>
          <div v-else>
            <v-btn outlined small class="date-button" color="accent" @click="showDay(day)">{{dayName(day)}} <br>{{crewName(day.crew)}} </v-btn>
          </div>
        </v-col>
      </div>
      <v-col v-if="!isDisabled"  style="margin-top:auto; margin-bottom:auto;">
        <v-tooltip bottom color="secondary">
          <template v-slot:activator="{ on }">
            <v-btn @click="showDay(null)"
                   class="text-right"
                   color="accent"
                   small
                   icon
                   dark
                   height="28"
                   width="28"
                   style="float:right;"
                   v-on="on">
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </template>
          <span>Add a day to the schedule</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-card flat class="card-border" v-if="showScheduleDay">
      <v-form ref="form" v-model="valid" :disabled="isDisabled">
        <div style="text-align: right;" v-if="!isDisabled">

          <v-tooltip bottom color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn @click="swapTimeSpan()"
                     class="text-right"
                     color="accent"
                     small
                     icon
                     dark
                     height="28"
                     width="28"
                     v-on="on"
                     :disabled="spanDisabled()">
                <v-icon>mdi-calendar-week</v-icon>
              </v-btn>
            </template>
            <span>Switch between day, multi day schedule</span>
          </v-tooltip>

          <v-tooltip bottom color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn @click="deleteConfirmDialog = true"
                     class="text-right"
                     color="error"
                     small
                     icon
                     dark
                     height="28"
                     width="28"
                     v-on="on">
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>Delete Day From Schedule</span>
          </v-tooltip>
          <v-tooltip bottom color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn @click="hideDay()"
                     class="text-right"
                     color="error"
                     small
                     icon
                     dark
                     height="28"
                     width="28"
                     v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </div>
        <v-row justify="center">
          <v-col cols="4" sm="4" style="height:75px">
            <v-dialog ref="scheduleDialog"
                      :return-value.sync="setDay.day"
                      persistent
                      width="290px"
                      v-model="scheduleDateModal">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="setDay.day"
                              label="Schedule Day"
                              readonly
                              v-on="on"
                              :rules="[v => checkInRange(v) || 'Scheduled day must fall between start and completion dates']"></v-text-field>
              </template>
              <v-date-picker v-model="setDay.day" type="date" @input="$refs.scheduleDialog.save(setDay.day)"
                             scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="accent" @click="scheduleDateModal = false">Cancel</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="4" sm="4" style="height:75px" v-if="isTimespan">
            <v-dialog ref="scheduleDialogTwo"
                      :return-value.sync="setDay.dayTwo"
                      persistent
                      width="290px"
                      v-model="scheduleTwoDateModal">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="setDay.dayTwo"
                              label="Schedule End Day"
                              readonly
                              v-on="on"
                              :rules="[v => checkInRange(v) || 'Scheduled day must fall between start and completion dates']"></v-text-field>
              </template>
              <v-date-picker v-model="setDay.dayTwo" type="date" @input="$refs.scheduleDialogTwo.save(setDay.dayTwo)"
                             scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="accent" @click="scheduleTwoDateModal = false">Cancel</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="4" sm="4" style="height:75px" v-if="isTimespan">
          </v-col>
            <v-col cols="4" sm="4" style="height:75px" v-if="!isTimespan">
              <v-dialog ref="startTimeDialog"
                        :return-value.sync="setDay.startTime"
                        persistent
                        width="290px"
                        v-model="startTimeModel">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="setDay.startTime"
                                label="Start Time"
                                readonly
                                hint="Start time must be greater then end time"
                                :persistent-hint="timeHint"
                                :rules="[v => v != null || 'Start Time is Required']"
                                v-on="on"></v-text-field>
                </template>
                <v-time-picker v-model="setDay.startTime" :ampm-in-title="true" @input="$refs.startTimeDialog.save(setDay.startTime)"
                               scrollable>
                  <div class="flex-grow-1"></div>
                  <v-btn text color="accent" @click="startTimeModel = false">Cancel</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>
            <v-col cols="4" sm="4" style="height:75px" v-if="!isTimespan">
              <v-dialog ref="endTimeDialog"
                        :return-value.sync="setDay.endTime"
                        persistent
                        width="290px"
                        v-model="endTimeModel">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="setDay.endTime"
                                label="End Time"
                                readonly
                                :persistent-hint="timeHint"
                                hint="End time must be greater then start time"
                                :rules="[v => v != null || 'End Time is Required']"
                                v-on="on"></v-text-field>
                </template>
                <v-time-picker v-model="setDay.endTime" :ampm-in-title="true" @input="$refs.endTimeDialog.save(setDay.endTime)"
                               scrollable>
                  <div class="flex-grow-1"></div>
                  <v-btn text color="accent" @click="endTimeModel = false">Cancel</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-col>

            <v-col cols="12" sm="12" style="height:75px;">
              <v-select label="Crew Name / Number"
                        :items="crews"
                        v-model="setDay.crewId"
                        chips
                        :persistent-hint="crewHint"
                        :rules="[v => v != null || 'Crew is Required']"
                        hide-no-data
                        append-icon="mdi-plus"
                        hint="A crew needs to be added"
                        item-text="text"
                        item-value="value">
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip v-bind="attrs"
                          :input-value="selected.value"
                          @click="select">
                    <strong>{{ `${item.text}` }}</strong>
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea label="Notes" :rows="1" :persistent-hint="noteHint" hint="Note will save after a few seconds" auto-grow @keyup="noteTimeOut" v-model="setDay.note"></v-textarea>
            </v-col>

            <div v-if="!isSaved"><p style="color:red;">{{notSavedMessage}} {{errorMessage}}</p></div>

</v-row>
      </v-form>

        <template>
          <v-row justify="center">
            <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline pt-1 pr-1">
                  Confirm Deletion
                  <v-spacer></v-spacer>
                  <v-btn icon @click="deleteConfirmDialog = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1"> Are you sure you want to delete this scheduledDay?</v-card-text>
                <v-alert v-if="this.error !=null && this.error !=='Error gettting schedule for task'" color="error" dark><v-icon size="20" dark>warning</v-icon>{{this.error}}</v-alert>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn outlined color="error" @click="remove()">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
    </v-card>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'schedule-day',
    data: () => ({
      showScheduleDay: false,
      deleteConfirmDialog: false,
      scheduleDateModal: false,
      scheduleTwoDateModel: false,
      startTimeModel: false,
      endTimeModel: false,
      setDay: {
        day: null,
        dayTwo: null,
        startTime: null,
        endTime: null,
        crewId: null,
        note: null
      },
      isSaved: false,
      notSavedMessage: 'Not saved',
      errorMessage: '',
      noteHint: false,
      timeHint: false,
      crewHint: false,
      scheduleDay: { id: 0, start: null, end: null},
      valid: true,
      isTimespan: false
    }),
    watch: {
      task: {
        handler(oldValue, newValue) {
          if (oldValue.id === newValue.id) {
             if (this.$refs.form !== undefined) {
                this.$refs.form.validate()
              }
              if (this.validOkToSave()) {
                  this.save()
              }
          } else {
           this.hideDay()
          }
        }
      },
     setDay: {
       handler() {
         //had to seperate out note, otherwise every keyup is a save
         if (this.setDay.note !== this.scheduleDay.note) {
           this.isSaved = false
           this.noteHint = true
         }

         if (this.checkDifference()) {
             this.isSaved = false
           if (this.validOkToSave() ) {
               this.save()
             }
         }
       }, deep: true
     }
    },
  methods: {
    ...mapActions({
      updateDay: 'schedule/updateScheduledDay',
      createDay: 'schedule/createScheduledDay',
      deleteDay: 'schedule/deleteScheduledDay',
      addCrew: 'workOrderTask/addCrew',
    }),
    dayName(day) {
      let date = new Date(day.start)
      let dateEnd = new Date(day.end)
      let display = ''

      if (date.getDay() != dateEnd.getDay()) {
        display = date.toDateString().slice(0,10) + ' - '+ dateEnd.toDateString().slice(0,10)
      } else {
        display= date.toDateString().slice(0,10)+ ', '+day.start.slice(11,16)+ ' - '+ day.end.slice(11,16)
      }

      return display
    },
    hideDay() {
      this.showScheduleDay = false
      this.scheduleDay = { id: 0, start: null, end: null }
      this.setDay = { day: null, dayTwo: null, startTime: null, endTime: null, crewId: null, note: null }
    },
    showDay(value) {
      if (value === null) {
        this.scheduleDay = {
          id: 0,
          start: null,
          end: null
        }
      } else {
        this.scheduleDay = value
      }

      this.setValues()
      this.showScheduleDay = true
    },
    noteTimeOut() {
      this.isSaved = false
        if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        }
      this.timer = setTimeout(() => {
        if (this.validOkToSave()) {
            this.save()
            this.noteHint = false
          }
        }, 800);
    },
    async save() {
      let schedule = {}
      if (this.isTimespan) {
        schedule = {
          start: this.setDay.day,
          end: this.setDay.dayTwo,
          crewId: this.setDay.crewId,
          note: this.setDay.note,
          workOrderTaskId: this.task.id
        }
      } else {
        schedule = {
          start: this.setDay.day + 'T' + this.setDay.startTime,
          end: this.setDay.day + 'T' + this.setDay.endTime,
          crewId: this.setDay.crewId,
          note: this.setDay.note,
          workOrderTaskId: this.task.id
        }
      }


      if (this.scheduleDay.id === 0) {
        await this.createDay(schedule)
      } else {
        schedule.id = this.scheduleDay.id
        await this.updateDay(schedule)
      }

      if (this.error === null) {
        this.isSaved = true
        this.noteHint = false
        this.scheduleDay = this.changedScheduleDay
        if (schedule.crewLeadId !== null) {
          if (!this.crewsOnTask.includes(schedule.crewId)) {
            let crewToAdd = {
              taskId: schedule.workOrderTaskId,
              crewId: schedule.crewId
            }
            this.addCrew(crewToAdd)
          }
        }
      } else {
        this.errorMessage = this.error
      }
    },
    async remove() {
      if (this.scheduleDay.id !== 0) {
        await this.deleteDay(this.scheduleDay.id)
      }

      if (this.error === null || this.scheduleDay.id === 0) {
        this.showScheduleDay = false
        this.deleteConfirmDialog = false
      }
    },
    setValues() {
      if (this.scheduleDay.id !== 0) {
        this.isSaved = true // if its reset and not a blank day, then the values are back to the saved ones
        if (this.scheduleDay.start.slice(0, 10) !== this.scheduleDay.end.slice(0, 10)){

          this.setDay ={
            day: this.scheduleDay.start.slice(0,10),
            dayTwo: this.scheduleDay.end.slice(0, 10),
            startTime: null,
            endTime: null,
            crewId: this.scheduleDay.crewId,
            note: this.scheduleDay.note
          }

          this.isTimespan = true
        } else {
           this.setDay = {
             day: this.scheduleDay.start.slice(0, 10),
             dayTwo: null,
              startTime: this.scheduleDay.start.slice(11,16),
              endTime: this.scheduleDay.end.slice(11,16),
              crewId: this.scheduleDay.crewId,
              note: this.scheduleDay.note
            }
          this.isTimespan = false
        }

          } else {
            this.isSaved = false
            this.isTimespan = false
            this.setDay = {
              day:  this.task.startDate.slice(0, 10),
              startTime: this.defaultTimes.start,
              endTime: this.defaultTimes.end,
              crewId: null,
              note: null
            }
      }
      this.crewHint = this.setDay.crewId !== null ? false : true
      this.errorMessage =''
    },
    swapTimeSpan() {
      if (this.isTimespan) {
        this.isTimespan = false
        this.setDay.dayTwo = null
        this.setDay.startTime = this.defaultTimes.start
        this.setDay.endTime = this.defaultTimes.end
      } else {
        this.isTimespan = true
        this.setDay.startTime = null
        this.setDay.endTime = null

      }
    },
    checkDifference() {
      let isDifferent = false

      if (this.scheduleDay.id !== 0) {
        if (this.setDay.crewId !== this.scheduleDay.crewId) { isDifferent = true }
        if (this.isTimespan) {
          if (this.setDay.day !== this.scheduleDay.start.slice(0, 10)) { isDifferent = true }
          if (this.setDay.dayTwo !== this.scheduleDay.end.slice(0, 10)) { isDifferent = true }
        } else {
          if (this.setDay.day !== this.scheduleDay.start.slice(0, 10)) { isDifferent = true }
          if (this.setDay.startTime !== this.scheduleDay.start.slice(11, 16)) { isDifferent = true }
          if (this.setDay.endTime !== this.scheduleDay.end.slice(11, 16)) { isDifferent = true }
        }
      } else {
        isDifferent = true
      }
      return isDifferent
    },
    validOkToSave() {
      let isValid = true


      //Day in range (this is auto set to start so will never be null)
      if (!this.checkInRange(this.setDay.day)) {
        isValid = false
      }

      if (this.isTimespan) {
        if (!this.checkInRange(this.setDay.dayTwo)) {
          isValid = false
        }

      } else {
        if ( ! this.checkTime(this.setDay.startTime, this.setDay.endTime)) {
          isValid = false
        }
        if (this.setDay.startTime === null || this.setDay.endTime === null) { isValid = false }
      }
       if ( this.setDay.crewId === null ) { isValid = false }  //After Auto creation will need to add in a crew

      return isValid
    },
    checkInRange (value) {
      let checked = false
      let day = new Date(value)
      let start = new Date(this.task.startDate.slice(0, 10))
      let end = new Date(this.task.completionDate.slice(0, 10))
      if (start <= day && day <= end) {
        checked = true
      }

      return checked
    },
    checkTime(start, end) {
      let checked = true

      if (start > end) {
        checked = false
        this.timeHint = true
      } else {
        this.timeHint = false
      }

       return checked
    },
    crewName(crew) {
      if (crew) {
        return crew.crewLead.firstName + ' '+ crew.crewLead.lastName
      } else {
        return 'Select A Crew'
      }
    },
    spanDisabled() {
      if (this.scheduleDay.id === 0) {
        return false
      } else {
        return true
      }
    }

  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      error: 'schedule/error',
      schedule: 'schedule/scheduleByTask',
      changedScheduleDay: 'schedule/scheduleDay',
      userRole: 'user/role',
      userId: 'user/id',
      crews: 'crew/selectList',
      defaultTimes: 'schedule/getDefaultTimes'
    }),
    isDisabled () {
      if (this.userRole === 'Sub Foreman') {
        return true
      } else {
        return false
      }
    },
    crewsOnTask() {
       return this.task.crews.map(crew => {
        return crew.value.id
      })

    },
    scheduleFiltered() {
      if (this.userRole !== 'Sub Foreman') {
        return this.schedule
      } else {
        return this.schedule.filter(s => {
          if (s.crew.crewLeadId === this.userId) {
            return s
          }
        })
      }
    }
  }
}
</script>
<style>
  .card-border {
    border-style: solid;
    border-color: #f0a73a !important;
    border-width: 1px;
    margin-top: 12px;
    margin-bottom: 12px;
    padding-left: 5px;
    padding-right: 5px;
  }
</style>
